import React, { HTMLAttributes } from 'react'
import classNames from 'classnames'
import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export interface INavigationItemMenuProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Determines whether to hide or show the menu
   * @default false
   */
  isOpen?: boolean
  /**
   * Displays mobile version
   * @default false
   */
  isMobile?: boolean
}

const useNavigationItemMenuStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    width: 'auto',
    padding: theme.spacing(1.5),
    border: `1px solid ${brandColors.coolGray5}`,
    borderTopColor: brandColors.white,
    backgroundColor: brandColors.white,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    color: brandColors.coolGray8,
  },
  open: {
    display: 'block',
    position: 'fixed',
    top: 48,
    left: theme.spacing(2),
    right: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
      top: 48,
      left: '50%',
      right: 'auto',
      transform: 'translate(-66%, 0)',
      width: 'auto',
    },
  },
}))

const NavigationItemMenu = ({
  className: classNameProp,
  isOpen = false,
  ...rest
}: INavigationItemMenuProps) => {
  const classes = useNavigationItemMenuStyles()
  const className = classNames(classes.root, classNameProp, {
    [classes.open]: !!isOpen,
  })
  return <div data-test='NavigationItemMenu' className={className} {...rest} />
}

export default NavigationItemMenu
